var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 105,
    viewBox: "0 0 149 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.68286 68.9334H16.1975C16.6988 68.9334 17.1465 68.6195 17.3174 68.1481L24.1367 49.3386C24.5255 48.2663 26.0537 48.3007 26.3938 49.3894L35.9575 80.0011C36.3301 81.194 38.054 81.0813 38.2682 79.8502L47.0403 29.4459C47.2743 28.1013 49.2183 28.1424 49.3952 29.4956L58.7082 100.715C58.8907 102.11 60.917 102.091 61.0734 100.693L69.7983 22.6411C69.8577 22.1092 69.5579 21.5996 69.0972 21.3273C67.5443 20.4093 64.2773 17.8598 64.2773 12.6583C64.2773 6.89465 68.7842 3.23828 74.0423 3.23828C79.3003 3.23828 83.8072 7.10973 83.8072 12.6583C83.8072 17.8475 80.63 20.3971 79.1083 21.3207C78.6524 21.5975 78.3566 22.107 78.418 22.6369L87.4866 100.896C87.6482 102.29 89.6678 102.306 89.8511 100.914L99.243 29.6026C99.4216 28.2468 101.371 28.2113 101.599 29.5598L110.082 79.7923C110.29 81.0277 112.02 81.1451 112.394 79.9492L121.941 49.3894C122.281 48.3007 123.809 48.2663 124.198 49.3386L131.017 68.1481C131.188 68.6195 131.636 68.9334 132.137 68.9334H145.64",
    stroke: "#C4C9CF",
    strokeWidth: 5.1056,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveIcon);
export default __webpack_public_path__ + "static/media/wave-icon.f0d6858558377d62a5c8602383ee1a9a.svg";
export { ForwardRef as ReactComponent };